export default __webpack_public_path__ + "static/media/pb_quesidilla.575bcb92.jpg";